import { EmailConfig } from '../email/types';

export const emailConfig: EmailConfig = {
  sender: {
    name: 'XTAX GmbH & Co. KG',
    email: 'lohn@xtax.de'
  },
  replyTo: 'lohn@xtax.de',
  greetingTemplate: 'Sehr geehrte Damen und Herren,',
  closingTemplate: 'Mit freundlichen Grüßen',
  signatureHtml: `
    <div style="margin-top: 40px; border-top: 2px solid #e0e0e0; padding-top: 20px;">
      <p style="margin: 0; font-weight: bold; color: #333;">XTAX GmbH & Co. KG</p>
      <p style="margin: 5px 0; color: #666;">Hansaring 78, 50670 Köln</p>
      <p style="margin: 5px 0; color: #666;">Tel: +49 221 6505419801</p>
      <p style="margin: 5px 0; color: #666;">E-Mail: lohn@xtax.de</p>
      <p style="margin: 5px 0; color: #666;">Web: www.xtax.de</p>
    </div>
  `
};